import * as React from 'react';
import { Query } from '@apollo/client/react/components';
import { QueryResult } from '@apollo/client';
import { decamelizeKeys } from 'humps';
import formatStoreToProps from './util/formatStoreToProps';
import {
  trackPerformanceEvent,
  getPerformanceEvent,
  APP_TIME_TO_INTERACTIVE,
} from '~/util/performanceTrack';
import { Props, QueryResponse, QueryVariables } from './types';

const applicationQuery = require('./applicationQuery.graphql');

class ApplicationQuery extends React.PureComponent<Props> {
  get variables() {
    const { applicationId } = this.props;

    return decamelizeKeys({
      applicationId,
    });
  }

  handleQueryCompleted() {
    const isInitialRender = getPerformanceEvent(APP_TIME_TO_INTERACTIVE);

    if (isInitialRender) {
      trackPerformanceEvent(APP_TIME_TO_INTERACTIVE);
    }
  }

  render() {
    const { children } = this.props;

    return (
      <Query
        query={applicationQuery}
        variables={this.variables}
        onCompleted={this.handleQueryCompleted}
      >
        {({ data, loading, refetch, client }: QueryResult<QueryResponse, QueryVariables>) => {
          if (loading) {
            return children({
              ...this.props,
              loading,
            });
          }

          const formattedProps = formatStoreToProps(data, {
            refetchApplication: refetch,
            client,
            ...this.props,
          });

          return children(formattedProps);
        }}
      </Query>
    );
  }
}

export default ApplicationQuery;
